import React from 'react';
import { Header } from '../Header';
import { BottomNavigation } from '../BottomNavigation';
import { ViewMode } from '../../types';

interface MainLayoutProps {
    currentView: ViewMode['current'];
    onViewChange: (view: ViewMode['current']) => void;
    currentZoneText: string;
    onZoneClick: () => void;
    hideZoneInfo?: boolean;
    activeTab: string;
    onTabChange: (tab: string) => void;
    children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
    currentView,
    onViewChange,
    currentZoneText,
    onZoneClick,
    hideZoneInfo = false,
    activeTab,
    onTabChange,
    children
}) => {
    const showSlidingTabs = currentView === 'list' || currentView === 'map';
    const showBottomNav = currentView !== 'welcome' && currentView !== 'add-zone' && currentView !== 'permissions' && currentView !== 'replacement-loading';

    return (
        <div className="app-container">
            <Header
                currentZone={currentZoneText}
                onZoneClick={onZoneClick}
                hideZoneInfo={hideZoneInfo}
            />

            {currentView === 'map' ? (
                children
            ) : (
                <div className="app-content">
                    {children}
                </div>
            )}

            {showSlidingTabs && (
                <div className="sliding-tabs">
                    <div className="tab-slider">
                        <div className={`tab-indicator ${currentView === 'map' ? 'right' : ''}`}></div>
                    </div>
                    <button
                        className={`tab-btn ${currentView === 'list' ? 'active' : ''}`}
                        onClick={() => onViewChange('list')}
                    >
                        List
                    </button>
                    <button
                        className={`tab-btn ${currentView === 'map' ? 'active' : ''}`}
                        onClick={() => onViewChange('map')}
                    >
                        Map
                    </button>
                </div>
            )}

            {showBottomNav && (
                <BottomNavigation
                    activeTab={activeTab}
                    onTabChange={onTabChange}
                    isVisible={showBottomNav}
                />
            )}
        </div>
    );
};
